import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useMe } from '@/api/me'
import { AppShellSkeleton } from '@/components/app-shell/app-shell-skeleton'
import { FullPageMessage } from '@/components/full-page-message'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Link } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  component: EntryPage,
})

// One membership: straight into it. Several: the most recently used one, which the API returns
// first; the picker below is the fallback when none has been used yet (G31). A Demo workspace is
// never the landing while the user has a real one (09 Onboarding); it stays in the switcher.
function EntryPage() {
  const { t } = useTranslation()
  const { data: me, isPending, isError } = useMe()

  if (isPending) return <AppShellSkeleton />
  if (isError || !me) return <Navigate to="/login" replace />

  const real = me.memberships.filter((membership) => !membership.workspace.demo)
  const [first, ...rest] = real.length > 0 ? real : me.memberships
  // Signed in but invited nowhere (or deactivated everywhere): say so instead of bouncing.
  if (!first) return <FullPageMessage title={t('noWorkspace.title')} body={t('noWorkspace.body')} />
  if (rest.length === 0 || first.last_used_at) {
    return <Navigate to="/w/$slug" params={{ slug: first.workspace.slug }} replace />
  }

  return (
    <main className="flex min-h-svh items-center justify-center p-4">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle className="font-heading text-xl">{t('workspacePicker.title')}</CardTitle>
          <CardDescription>{t('workspacePicker.subtitle')}</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-2">
          {me.memberships.map((membership) => (
            <Button key={membership.workspace.slug} asChild variant="outline" className="justify-start">
              <Link to="/w/$slug" params={{ slug: membership.workspace.slug }}>
                {membership.workspace.name}
              </Link>
            </Button>
          ))}
        </CardContent>
      </Card>
    </main>
  )
}
